/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcaptionplaceholder2Inputs */

const en_crosspostingcaptionplaceholder2 = /** @type {(inputs: Crosspostingcaptionplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your post…`)
};

const de_crosspostingcaptionplaceholder2 = /** @type {(inputs: Crosspostingcaptionplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibe deinen Beitrag…`)
};

/**
* | output |
* | --- |
* | "Write your post…" |
*
* @param {Crosspostingcaptionplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcaptionplaceholder2 = /** @type {((inputs?: Crosspostingcaptionplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcaptionplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcaptionplaceholder2(inputs)
	return de_crosspostingcaptionplaceholder2(inputs)
});
export { crosspostingcaptionplaceholder2 as "crosspostingCaptionPlaceholder" }